export const containHorizontalNavigation = (element: HTMLElement) => {
  const roots = [document.documentElement, document.body];
  let previous: string[] | null = null;

  const contain = () => {
    if (previous !== null) return;
    previous = roots.map((root) => root.style.overscrollBehaviorX);
    for (const root of roots) root.style.overscrollBehaviorX = 'none';
  };

  const restore = () => {
    if (previous === null) return;
    for (const [index, root] of roots.entries()) {
      root.style.overscrollBehaviorX = previous[index];
    }
    previous = null;
  };

  const update = (event: Event) => {
    if (event.target instanceof Node && element.contains(event.target)) {
      contain();
    } else {
      restore();
    }
  };

  document.addEventListener('pointerover', update, true);
  document.addEventListener('wheel', update, { capture: true, passive: true });
  element.addEventListener('pointerleave', restore);
  window.addEventListener('blur', restore);
  if (element.matches(':hover')) contain();

  return () => {
    document.removeEventListener('pointerover', update, true);
    document.removeEventListener('wheel', update, true);
    element.removeEventListener('pointerleave', restore);
    window.removeEventListener('blur', restore);
    restore();
  };
};
